import { Link } from "react-router-dom";
import VideoCard from "@/components/feature/VideoCard";
import { videos } from "@/mocks/videos";

const shorts = videos.filter((item) => item.type === "short").slice(0, 6);

export default function ShortStrip() {
  return (
    <section className="border-y border-background-200 bg-background-100 py-12 md:py-16">
      <div className="page-shell">
        <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="mb-2 flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.2em] text-accent-300">
              <span className="h-px w-6 bg-accent-400" />
              Short & fresh
            </p>
            <h2 className="font-heading text-xl font-semibold tracking-tight text-foreground-950 md:text-2xl">
              短视频 · 几分钟就够开心
            </h2>
            <p className="mt-1.5 text-sm text-foreground-600">
              搞笑、美食、旅行、生活与音乐，碎片时间也能看得有滋有味。
            </p>
          </div>
          <Link
            to="/category/short"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-accent-300"
          >
            全部短视频
            <i className="ri-arrow-right-line text-base" />
          </Link>
        </div>

        <div className="no-scrollbar -mx-1 flex snap-x snap-mandatory gap-4 overflow-x-auto px-1 pb-2">
          {shorts.map((video) => (
            <div key={video.id} className="w-[268px] shrink-0 snap-start sm:w-[288px]">
              <VideoCard video={video} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}